<app-header></app-header>
<app-welcome></app-welcome>
<app-characteristics></app-characteristics>
<app-footer></app-footer>
<section>
    <jjva-ngx-whatsapp-button [ngx_whatsapp_phone]="phone" [ngx_whatsapp_text]="title">
    </jjva-ngx-whatsapp-button>
</section>